.gameLobbyFrame {
  display: flex;
  flex-flow: column nowrap;

  position: relative;
}

.topBar {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  padding: 1px 16px;

  position: absolute;
  top: 0;

  z-index: 10;
}

.left,
.right {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.left {
  justify-content: flex-start;
}

.right {
  justify-content: flex-end;
}

.logoAndBrand {
  height: 60px;
}
